var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg34(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2130_3343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#111111",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 -62C20.482 -62 35.0213 -53.6913 43.6642 -41.0355C43.8808 -40.7182 43.7786 -40.2851 43.446 -40.093L14.3226 -23.2784C14.1163 -23.1593 13.8622 -23.1593 13.6559 -23.2784L9.31934 -25.7822C-0.246517 -31.3051 -12.4791 -28.0278 -18.002 -18.4619C-20.6412 -13.8902 -21.2694 -8.70968 -20.1629 -3.94359C-20.0951 -3.65173 -20.2216 -3.34745 -20.4811 -3.19763L-31.1738 2.97656C-31.764 3.31776 -31.5218 4.22071 -30.8398 4.2207H-16.466C-16.2662 4.2207 -16.0775 4.31068 -15.9484 4.46314C-14.499 6.17539 -12.7351 7.67229 -10.6807 8.8584L5.22363 18.041C14.1933 23.2195 24.3835 24.3597 33.6962 22.0328C34.3928 21.8588 34.8896 22.7433 34.3335 23.1974C26.0655 29.9487 15.5067 34 4 34C-22.5097 34 -44 12.5097 -44 -14C-44 -40.5097 -22.5097 -62 4 -62Z",
    fill: "#111111",
    fillOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z",
    stroke: "#111111",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2130_3343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg34);
export default __webpack_public_path__ + "static/media/3_4.a19c7fe1f065a3593e6d9e5f68e896f6.svg";
export { ForwardRef as ReactComponent };